// The whole dashboard talks to one backend (the web-enterprise Rails API).
// Set REACT_APP_API_BASE_URL to its origin, e.g.
//   staging: https://web-enterprise-alt-server.onrender.com
//   prod:    https://api.groov-enterprise.com
//
// This used to read three vars (REACT_APP_AUTH_BASE_URL, REACT_APP_API_BASE_URL,
// REACT_APP_API_BASE_DEV_URL) that were always set to the same value — now one.
// Note: the legacy notification/player/app-release/enterprise pages call paths
// this backend doesn't serve, so they 404 until ported; the order admin is
// fully served here.
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3000";

const Constants = {
  API_BASE_URL,
  AUTH_BASE_URL: API_BASE_URL, // alias kept so existing imports keep working
};

export default Constants;
